import React, { useState, useContext, useEffect } from 'react';
import { StateContext, DispatchContext } from 'context';
import { Helper } from 'utils';
import { Api } from 'services';
import { AppActions } from 'store';
import { Themes } from 'styles';
import { useSnackbar } from 'notistack';
import { DescuentoDeCheques1Img, DescuentoDeCheques2Img } from 'assets/img';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormularioDescuentoCheques } from 'app/formulario-descuento-cheques';
import './descuento-de-cheques.css';


const DescuentoDeCheques = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const state = useContext(StateContext);
    const dispatch = useContext(DispatchContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [verFormularioPersonaFisica, setVerFormularioPersonaFisica] = useState(false);
    const [verFormularioPersonaJuridica, setVerFormularioPersonaJuridica] = useState(false);
    const [msgEnvioExitoso, setMsgEnvioExitoso] = useState("");
    const [data, setData] = useState({
        nombre: "",
        apellido: "",
        numDocumento: "",
        email: "",
        telefono: ""
    });
    const [errores, setErrores] = useState({
        nombre: false,
        apellido: false,
        numDocumento: false,
        email: false,
        telefono: false
    });
    useEffect(() => {
        // console.log('Themes[indexTema].D1', Themes[indexTema].D1);
    }, []);
    const onChangeForm = (event, campo) => {
        setData({
            ...data,
            [campo]: event.target.value
        });
        setErrores({
            ...errores,
            [campo]: false
        });
    }
    const solicitar = () => {
        const { nombre, apellido, email, telefono } = data;
        let todoBien = true;
        let errors = {
            nombre: false,
            apellido: false,
            email: false,
            telefono: false,
        };
        if (nombre && nombre !== "") {
            // datos.nombre = nombre;
        } else {
            todoBien = false;
            errors.nombre = true;
        }
        if (apellido && apellido !== "") {
            // datos.apellido = apellido;
        } else {
            todoBien = false;
            errors.apellido = true;
        }
        if (email && email !== "" && Helper.validateEmail(email)) {
            // datos.email = email;
        } else {
            todoBien = false;
            errors.email = true;
        }
        if (telefono && telefono !== "") {
            // datos.telefono = telefono;
        } else {
            todoBien = false;
            errors.telefono = true;
        }
        if (todoBien) {
            console.log('data', data);
        }
        console.log('todoBien', todoBien);
        console.log('errores', errors);
        console.log('data', data);
        setErrores(errors);
        if (todoBien) {
            dispatch(AppActions.setLoading(true));
            dispatch(AppActions.setActionsDisabled(true));
            var options = {
                url: Api.route('/solicitar-credito'),
                method: 'POST',
                data: data
            };
            Api.request(options, response => {
                Helper.log('solicitarCredito response', response);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
                if (response.codigo && response.codigo !== 200) {
                    enqueueSnackbar(response.mensaje, { variant: 'error' });
                } else if (response.codigo && response.codigo === 200) {
                    setData({
                        nombre: "",
                        apellido: "",
                        numDocumento: "",
                        email: "",
                        telefono: ""
                    });
                    setMsgEnvioExitoso("Hemos recibido tu solicitud, nos comunicaremos contigo para ayudarte con los siguientes pasos");
                    setTimeout(() => {
                        setMsgEnvioExitoso("");
                    }, 6000);
                }
            }, error => {
                Helper.log('error solicitarCredito', error);
                dispatch(AppActions.setLoading(false));
                dispatch(AppActions.setActionsDisabled(false));
            });
        }
    }

    return (
        <>
            <div id="descuento-de-cheques" className="w3-block">
                <div className="w3-content w3-center w3-padding-large">

                </div>
                <div className="w3-content">
                    <div className="w3-row">
                        <div className="w3-col l4 m12 col-imagenes">
                            <div className="w3-row">
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${DescuentoDeCheques1Img})` }}>
                                        </div>
                                    </div>
                                </div>
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${DescuentoDeCheques2Img})` }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="w3-col l4 m4 w3-center w3-hide-small">
                            <img src={DescuentoDeChequesImg} alt="descuento-de-cheques-img"/>
                        </div> */}
                        <div className="w3-rest w3-padding">
                            <h1 style={{ color: Themes[indexTema].D1 }}>Descuento de cheques</h1>
                            <p>SERFIN, ayuda a tu economía ¿Necesitas disponer de efectivo? Hoy mismo podés adelantar el cobro de tus cheques de pago diferido. Efectivizá tus cheques de forma rápida, segura, confiable y con mínimos   requisitos para agilizar tu operacion, sin moverte de tu casa u oficina y con la máxima reserva, completá el siguiente formulario:</p>
                            {(!verFormularioPersonaFisica && !verFormularioPersonaJuridica) ? <button className="boton-formulario-online w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioPersonaFisica(true)}>Solicitud (Persona Física)</button> : null}
                            {(!verFormularioPersonaFisica && !verFormularioPersonaJuridica) ? <button className="boton-formulario-online w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioPersonaJuridica(true)}>Solicitud (Persona Jurídica)</button> : null}
                        </div>

                    </div>
                    {verFormularioPersonaFisica ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioPersonaFisica(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud (Persona Física)</h1>
                            </div>
                            <FormularioDescuentoCheques tipoSolicitud={4} />
                        </div>
                    </div> : null}
                    {verFormularioPersonaJuridica ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioPersonaJuridica(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud (Persona Jurídica)</h1>
                            </div>
                            <FormularioDescuentoCheques tipoSolicitud={5} />
                        </div>
                    </div> : null}
                </div>
            </div>
        </>
    );
}
export default DescuentoDeCheques;